module.exports = __webpack_public_path__ + "img/stock3.46149670.png";